export enum ButtonType {
  submit = 'submit',
  reset = 'reset',
  button = 'button',
}

export enum ButtonKinds {
  default = 'default',
  success = 'success',
  primary = 'primary',
  secondary = 'secondary',
}
